 /* eslint-disable */

<template>
<div class="splash" v-if="splash_on">
    <v-img width="40%" max-width="589" max-height="182" :src="image_data"/>
</div> 
<v-app v-else class="ma-0" :dark="initialDark" :style="{background: $vuetify.theme.themes[theme].background}">
    <navigation v-if="!loading_dbs && loggedin" :toggle="toggle"></navigation>
    <v-app-bar class="align-center white--text cyan darken-2" app fixed clipped-left>
        <v-app-bar-nav-icon v-if="loggedin" @click="toggleMenu" class="white--text"></v-app-bar-nav-icon>
        <v-toolbar-title><v-img width="70%" max-width="216" :src="image_data_w"/></v-toolbar-title>
        <v-spacer></v-spacer>
        <v-switch dense class="pt-4 pr-4 ma-0" :label="`Tema scuro`" v-model="$vuetify.theme.dark" />
        <v-icon v-if="$store.state.offline" class="pa-2 white--text" color="error">wifi_off</v-icon>
        <v-icon v-else class="pa-2 white--text">wifi</v-icon>
        <v-btn icon v-if="loggedin" @click="logout"><v-icon class="pa-2 white--text">power_settings_new</v-icon></v-btn>
        <v-btn icon v-else @click="login"><v-icon class="pa-2 white--text">exit_to_app</v-icon></v-btn>
        <v-btn v-if="update_data.new_software_version" light class="ma-2 pa-2 white--text" @click="showUpdatePopup"><v-icon class="pr-2 white--text" color="error">system_update</v-icon>scarica aggiornamento</v-btn>
    </v-app-bar>
    <v-main>
        <div class="d-flex align-center justify-center flex-column my-8" v-if="loading_dbs && !loggedin">
            <h2>Sincronizzazione in corso...</h2>
            <v-progress-circular 
                indeterminate
                size="200"
                width="20"
                color="primary"
                ></v-progress-circular>
        </div>

        <v-container v-else>
            <div>
                <div class="d-flex justify-between">
                    <h1 class="d-flex">
                        <span v-for="(title,idx) of pageTitle" :key="title">{{title}}<v-icon v-if="idx<pageTitle.length-1" class="px-2" small color="black">double_arrow</v-icon></span>
                    </h1>
                    <v-spacer />
                    <v-btn icon @click="currentTS=(new Date()).getTime();"><v-icon class="pa-2">refresh</v-icon></v-btn>            
                </div>
                <router-view :key="$route.fullPath+'_'+currentTS"></router-view>
            </div>
        </v-container>
        <v-snackbar
            v-model="$store.state.snackbar.show"
            :color="$store.state.snackbar.color"
            :multi-line="true"
            centered
            class="view_on_top"
            >
            {{ $store.state.snackbar.text }}

            <template v-slot:action="{ attrs }">
                <v-btn
                dark
                text
                v-bind="attrs"
                @click="closeSnackbar"
                >
                CHIUDI
                </v-btn>
            </template>
            </v-snackbar>
        <v-footer
            app
            bottom fixed
            padless
            >
            <v-col cols="2" class="font-weight-medium text-center white--text cyan darken-2">
                &nbsp;
            </v-col>
            <v-col
                class="font-weight-medium text-center white--text cyan darken-2"
                cols="8"
            >
                <strong>&copy; {{ sw_org }} {{ sw_year}}</strong> | P.IVA {{ sw_piva }} | ver. {{version_number}} {{getBuildDate()}}
            </v-col>
            <v-col
                class="cyan darken-2 pa-0"
                cols="2"
            >
            <a class="font-weight-bold white--text text-decoration-none" target=”_blank” href="https://www.dsd-tech.it/">
                <v-img max-height="48" contain :src="image_powered"/>
            </a>
            </v-col>
        </v-footer>
        <BaseDialog 
                :max_width="`80%`"
                :dialog="update_data.viewUpdateExists"
                title="Aggiornamento disponibile"
                @close_dialog="rememberUpdateSoftware"
            >
                <p v-if="update_data.updating_software">Aggiornamento del software in corso.</p>
                <p v-else>Aggiornamento del software disponibile.</p>
                <template v-slot:action>
                    <div class="d-flex align-center justify-center my-4">
                        <v-progress-circular
                                v-if="update_data.updating_software"
                                indeterminate
                                size="32"
                                width="4"
                                color="primary"
                                ></v-progress-circular>
                        <span v-else><v-btn text @click="rememberUpdateSoftware">Rimanda</v-btn><v-btn @click="updateSoftware">Aggiorna</v-btn></span>

                    </div>
                </template>
            </BaseDialog>

            <BaseDialog 
                :max_width="`80%`"
                :dialog="fatalError"
                title="Errore inaspettato">
                <v-alert class="full-width title" type="error" :value="true">
                    <div class="full-width">Si è presentato un errore inaspettato: è necessario ricaricare la pagina.</div>
                </v-alert>
                <template v-slot:action>
                    <div class="d-flex align-center justify-center my-4">
                        <v-btn @click="reloadApp">Ricarica la pagina</v-btn>
                    </div>
                </template>
            </BaseDialog>
    </v-main>

    <v-dialog
        v-model="block_dialog"
        persistent
        :max-width="600"
        scrollable>
        <v-card class="elevation-0 pa-0 ma-0">
            <v-card-title class="ma-0 pa-0">
                <v-alert class="full-width title" type="error" :value="true">
                    <div class="full-width">Sessione di lavoro già in corso.</div>
                </v-alert>
            </v-card-title>
            <v-card-text class="pa-6 ma-0">
                <p class="subtitle-1">È possibile avere un'unica sessione (scheda/finestra) attiva.</p>
                <p class="subtitle-1">Il sistema potrebbe avere dei comportamenti anomali: 
                si prega di chiudere questa scheda/finestra per utilizzare il sistema correttamente
                e utilizzare sempre un'unica scheda/finestra.
                </p>
            </v-card-text>
        </v-card>
    </v-dialog>
</v-app>
</template>

<script>

//import {createInstrumentTestDoc} from "./utils/designDocs"
// import {db_names} from './utils/dbUtility'
import navigation from './components/utils/Navigation.vue'
import BaseDialog from './components/dialogs/BaseDialog'
import jwtDecode from "jwt-decode"

// test comment


export default {
    // test2
    name: 'App',
    components: {navigation, BaseDialog},
    data(){
        return {
            splash_on: true,
            toggle: true,
            baseblocks: [],
            instruments: [],
            version_number: "2.0.7",
            initialDark: this.$vuetify
                ? this.$vuetify.theme.dark
                : false,
            pageTitle: '',
            update_data: {
                refreshing: false,
                updating_software: false,
                registration: null,
                viewUpdateExists: false,
                new_software_version: false
            },
            update_timeout_ref: null,
            block_dialog: false,
            loading_dbs: true,
            dtoken: null,
            fatalError: false,
            currentTS: 0,
            loggedUser: null,
            image_data: "https://cdn.vuetifyjs.com/images/parallax/material.jpg",
            image_data_w: "https://cdn.vuetifyjs.com/images/parallax/material.jpg",
            mastercal_logo: "",
            sw_org: process.env.VUE_APP_SW_ORG_NAME,
            sw_year: process.env.VUE_APP_YEAR,
            sw_piva: process.env.VUE_APP_SW_ORG_PIVA
          }       
    },
   computed: {
        loggedin(){
            return this.$store.state.user!=null && this.$store.state.loggedin
        },
        theme(){
            return (this.$vuetify.theme.dark) ? 'dark' : 'light'
        }
    },
    watch:{
        $route (){
            let title = []
            for (let i = 0; i< this.$router.history.current.matched.length; i++) {
               if (this.$router.history.current.matched[i].meta.pageTitle) {
                    title.push(this.$router.history.current.matched[i].meta.pageTitle)
                }
            }
            this.pageTitle = title
        },
        '$store.state.logoutError': {
            deep: false,
            handler(){    
                if (this.$store.state.logoutError) {
                    this.$store.commit('loadingDbs', {loading: false})
                    this.$router.push({path: "/login", query: {error: 'dbSync'}})
                    // window.location.href("/login?error=dbSync")
                }
            }
        },
        '$store.state.fatalError': {
            deep: false,
            handler(){    
                if (this.$store.state.fatalError){
                    this.fatalError = true
                }

            }
        },
        "$store.state.loading_dbs": {
            deep: false,
            async handler(){
                console.log("APP VUE WATCH LOADING_DBS", this.loading_dbs, this.$store.state.loading_dbs)
                if (this.loading_dbs && !this.$store.state.loading_dbs && this.loggedUser) {
                    console.log("DISPATCH startSyncDbs", this.$store.state.loading_dbs)    
                    await this.$store.dispatch('startSyncDbs', {pouch: this.$store.state.$pouch, axios: this.axios, user: this.loggedUser})
                    this.$store.commit("login", { token: this.dtoken });
                    this.loading_dbs = false
                }
            }
        }
    },
    async beforeMount(){
        this.dtoken =null
        this.loading_dbs = true
        console.log("before mount start")
        this.$store.commit("setCurrentSoftwareVersion", this.version_number);
        if (!window.navigator.onLine) {
            this.$store.commit("offline", {});
            this.$store.commit("showSnackbar", {text: "Connessione assente", color: 'error'})
            console.log("network connection missed." );
        } else {
            this.$store.commit("online", {});
        }
        let session = await this.getSession();
        console.log("SESSION", session)
        if(session) {
            //this.$store.commit("login", session);
            this.loggedUser = session.user;
            await this.setupToken(this.loggedUser);
        } else {
            this.loading_dbs = false
            this.$store.commit("loadingDbs", {loading: false});
        }
        console.log("before mount end")
    },
    mounted () {
        this.image_powered = "/img/metrycal/powered_dsd_w.png";
        this.image_data = "/img/metrycal/logo.png"; //process.env.VUE_APP_CERTIFICATE_HOST + "/images/logo.png"
        this.image_data_w = "/img/metrycal/logo_w.png";
        this.mastercal_logo = "/img/metrycal/metrycal_512x512.png"; //process.env.VUE_APP_CERTIFICATE_HOST + "/images/logo.png"
        
        setInterval(() => {
            this.splash_on = false
        }, 2000);
        //this.dtoken =null
        //this.loading_dbs = true
    },
    beforeDestroy () {
        navigator.serviceWorker.removeEventListener('controllerchange', this.controllerChange)
        document.removeEventListener('SWUpdated', this.updateAvailable);
        window.removeEventListener('online', this.online)
        window.removeEventListener('offline', this.offline)
        this.removeEventListener('DBERROR', this.dbError)
    },
    created(){
        console.log("+++++++++++ CREATED", this)
        this.$store.commit("setPouches", {local_pouch: this.$pouch, remote_pouch: this.$pouch_remote});
        this.$on('DBERROR', this.dbError);
        this.$vuetify.lang.current = 'it'
        document.addEventListener('SWUpdated', this.updateAvailable);
        process.on('warning', e => console.warn("ERROR",e.stack));
        navigator.serviceWorker.addEventListener('controllerchange', this.controllerChange)
        window.addEventListener('offline', this.offline);
        window.addEventListener('online', this.online);
        window.addEventListener('error', function(event) {
            console.log("§§§§§§§§§§§§§§§§§§§", event)
            //handle error here
            //event.promise contains the promise object
            //event.reason contains the reason for the rejection
        });

    },
    methods: {
        reloadApp() {
            window.location.reload();
        },
        controllerChange() {
            if (this.update_data.refreshing) {
                console.log('data refreshing already setted')
                return
            }
            this.update_data.refreshing = true
            console.log('setting data refreshing', this.update_data.refreshing)
                // Here the actual reload of the page occurs
            this.reloadApp()
            //this.update_data.viewUpdateExists = false
            //this.update_data.updating_software = false
        },
        offline(event) {
            this.$store.commit("offline", event);
            this.$store.commit("showSnackbar", {text: "Connessione persa", color: 'error'})
            console.log("The network connection has been lost.", event);
        },
        async online(event) {
            this.$store.commit("online", {pouch: this.$store.state.$pouch, axios: this.axios, event: event});
            let session = await this.getSession()
            if (session) {
                console.log("doLogin USER", session.user)
                await this.$store.dispatch('setUser', {user: session.user})
                this.$store.commit("showSnackbar", {text: "Connessione ripristinata", color: 'primary'})
                console.log("The network connection has been restored.", event);
            }
        },
        dbError(event) {
            console.log("DBERROR - EEEEEEEEEEEEEEEE", event);
            let message = "Problemi di accesso al database"
            if (event.error.status == 409) {
                message = "Conflitto sul documento: ricaricare e riprovare ad effettuare l'operazione"
            }
            this.$store.commit("showSnackbar", {text: message, color: 'error'})
        },
        logout(){
            localStorage.removeItem("__jwt")
            localStorage.removeItem("user")
            localStorage.removeItem("mastercal_users")
            this.$store.commit("logout")
            this.reloadApp()
            //this.$router.push("/login")
            //window.location.reload()
        },
        login(){
            localStorage.removeItem("__jwt")
            localStorage.removeItem("user")
            localStorage.removeItem("mastercal_users")
            this.$store.commit("logout")
            this.$router.push("/login")
            //this.$router.push("/login")
        },
        toggleMenu() {
            this.toggle = !this.toggle;
        },
        
        back() {
            this.$router.push({path: this.back})
        },
        getBuildDate() {
            if (process.env.VUE_APP_BUILD_DATE) {
                return process.env.VUE_APP_BUILD_DATE
            } else {
                return ''
            }
        },
        closeSnackbar() {
            this.$store.commit("closeSnackbar")
        },
        async getSession() {
            let user = null;
            let token = null;
            let now = (new Date()).getTime();
            let that = this
            try {
                localStorage.openpages = now
                window.addEventListener('storage', function (e) {
                    if(e.key == "openpages") {
                        // Listen if anybody else is opening the same page!
                        localStorage.page_available = now;
                    }
                    if(e.key == "page_available") {
                        if (localStorage.page_available != now) {
                            that.block_dialog = true
                        }
                        //alert("sessione già aperta!");
                    }
                }, false);
                user = localStorage.getItem("user");
                let decodedUser = JSON.parse(user)
                token = localStorage.getItem("__jwt");
                if (!this.$store.state.offline && decodedUser) {
                    let res = await this.axios.get("/mastercal/users/" + decodedUser._id).catch(error => {
                        console.log("error status", error);
                        //this.errorMessage = "errore di connessione - riprovare. Se il problema persiste contattare l'amministratore"
                        decodedUser = null
                    });
                    if (res) {
                        decodedUser = res.data
                    }
                }
                
                let decodedToken = jwtDecode(token);
                if (decodedUser && !decodedUser.dismissed && decodedToken.exp*1000>now) {
                    return {token: decodedToken, user: decodedUser};
                } else {
                    if (decodedUser && decodedUser.dismissed) {
                        console.log("USER DISMISSED, deleting local dbs");
                        await this.$store.dispatch('deleteDbs', {pouch: this.$store.state.$pouch, user: this.loggedUser});
            
                        /* await this.$store.state.$pouch.disconnect('system')
                        await this.$store.state.$pouch.destroy('system')
                        for (let db of db_names){
                            console.log('delete db', db)
                            if (this.$store.state.localDb_pull[db]) {
                                await this.$store.state.localDb_pull[db].cancel()
                                
                                if (this.$store.state.localDb_push[db]) {
                                    await this.$store.state.localDb_push[db].cancel()
                                }
                     
                                    //awa@it that.$pouch.viewCleanup(db)
                        
                            }
                            await this.$store.state.$pouch.disconnect(db)
                            //await new PouchDB(db).destroy()
                            await this.$store.state.$pouch.destroy(db)
                            await this.$store.state.$pouch.viewCleanup(db)
                        } */
                    }
                    this.login()
                }
                //TODO delete token if not valid anymore?
            } catch(e) {
                console.log("Invalid token: not Loggedin",  e.message);
                this.login()
            }
            return null;
        },

        async setupToken(){
            this.loading_dbs = true
            let token = localStorage.getItem("__jwt");
            this.axios.defaults.headers.common['Authorization'] = "Bearer " + token;
            this.dtoken = jwtDecode(token)
            await this.$store.dispatch('setUser', {user: this.loggedUser, pouch_local: this.$pouch, pouch_remote: this.$pouch_remote})
            await this.$store.dispatch('setUsers', {pouch: this.$store.state.$pouch, axios: this.axios})
            let syncRes = await this.$store.dispatch('startSyncDbs', {pouch: this.$store.state.$pouch, axios: this.axios, user: this.loggedUser})
            console.log('SYNC RES', syncRes)
            if (!syncRes) {
                await this.$store.dispatch('startCopyDbs', {pouch: this.$store.state.$pouch, axios: this.axios, user: this.loggedUser})
            } else {
                this.$store.commit("login", { token: this.dtoken });
                this.loading_dbs = false
            }
        },
        updateAvailable (event) {
            this.update_data.new_software_version = true
            this.update_data.viewUpdateExists = true
            this.update_data.registration = event.detail
            console.log("******showRefreshUI", event)
        },
        showUpdatePopup () {
            clearTimeout(this.update_timeout_ref)
            this.update_data.viewUpdateExists = true
        },
        async updateSoftware() {
            let that = this;
            // windows reload if sentinel and no service worker is not registersterd
            if (that.update_data.registration.type=="sentinel" && that.update_data.registration.waiting === undefined) {
                console.log('window reload')
                window.location.reload()
            }
            // Make sure we only send a 'skip waiting' message if the SW is waiting
            if (!that.update_data.registration || !that.update_data.registration.waiting) {
                return
            }
            // Send message to SW to skip the waiting and activate the new SW
            that.update_data.updating_software = true
            setTimeout(function() {
                that.update_data.registration.waiting.postMessage({ type: 'SKIP_WAITING' })
                that.update_data.new_software_version = false
            }, 1000)
        },
        rememberUpdateSoftware() {
            let that = this;
            this.update_data.viewUpdateExists = false
            this.update_timeout_ref = setTimeout(function() {
                if (that.update_data.new_software_version){
                    that.update_data.viewUpdateExists = true
                }
            }, 3600000) // timeout after 1 hour
        }
    }
    
}
</script>

<style lang="scss">

#app {
  font-family: 'Avenir', Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: left;
}

td.table-blocks:not(:nth-child(1)),
td.table-blocks:not(:nth-child(1)),
td.table-blocks:first-child,
td.table-blocks:first-child{
    width: auto;
    padding: 0px 0px !important;
    &.top-align {
        display:table-cell;
        vertical-align: bottom;
    }
    &.with_scroll {
        min-width: 135px;
    }
}

th.table-text-blocks:not(:nth-child(1)),
th.table-text-blocks:not(:nth-child(1)),
th.table-text-blocks:first-child,
th.table-text-blocks:first-child,
td.table-text-blocks:not(:nth-child(1)),
td.table-text-blocks:not(:nth-child(1)),
td.table-text-blocks:first-child,
td.table-text-blocks:first-child{
    width: auto;
    padding: 6px 6px 0 12px !important;
    &.top-align {
        display: table-cell;
        vertical-align: bottom;
        padding-bottom: 8px !important;
    }
}


.no_padding{
    padding: 0px 0px !important;
}

input[type=number]::-webkit-inner-spin-button, 
input[type=number]::-webkit-outer-spin-button { 
    -webkit-appearance: none;
    -moz-appearance: none;
    appearance: none;
    margin: 0; 
}
input[type='number'] {
    -moz-appearance:textfield;
}

.v-input.error_field .v-input__control input{
    color: red;
}

.v-text-field.v-text-field--enclosed:not(.v-text-field--rounded) > .v-input__control > .v-input__slot {
    padding: 0 6px;
}

.v-text-field.v-text-field--enclosed:not(.v-text-field--rounded) > .v-input__control > .v-input__slot label{
    padding: 0 6px;
}


.centered-input input {
    text-align: center
}
.right-input input {
    text-align: right;
}
.left-input input {
    text-align: left
}

.add_table { 
  table {
    width: 100%;
  }
}

.full-width {
    width: 100% !important;
}

.measure_table {
    min-width: 100% !important;
    table {
        min-width: 100%;
        th {
            padding-top: 4px;
            min-width: 50px;
            vertical-align: top;
        }
    }
    .top-align {
        vertical-align: top;
    }
}

.cursor_pointer {
    cursor: pointer;
}

.v-snack--absolute.view_on_top {
    z-index: 9999;
}

input:disabled {
   color: var(--v-disabled-base) !important;
} 

.v-text-field--outlined:not(.v-input--is-focused).v-input--is-disabled > .v-input__control > .v-input__slot fieldset{
    border: 1px dotted ;
}

.v-application--is-ltr .v-list-group--no-action>.v-list-group__items>.v-list-item {
    padding-left: 42px;
}

.v-application--is-ltr .v-list-item__action:first-child, .v-application--is-ltr .v-list-item__icon:first-child {
    margin: 10px 12px 10px 0px ;
}

.splash {
  background-color: white;
  bottom: 0;
  color: white;
  display: block;
  font-size: 32px;
  left: 35%;
  overflow: hidden;
  position: fixed;
  text-align: center;
  top: 40%;
  width: 100%;
  height: 100%;
}

</style>
